<template>
  <div class="business">
    <div class="title">
      <div class="title-logo"></div>
      <div class="title-right">
        <div class="menu">
          <nx-nav />
        </div>
        <div class="title-user">
          <user-info v-if="!ifLogin"></user-info>
          <login-user v-if="ifLogin" class="tc"></login-user>
        </div>
      </div>
    </div>
    <div class="header" v-if="ifLogin">
      <span class="active" @click="changeHeightF()">关注网站</span>
    </div>
    <div class="loading" v-if="loadingShow === true">
      <div class="loadingImg"></div>
    </div>
    <div class="mask" v-show="actPro" @click="hidePro"></div>
    <div class="switchSite" v-if="ifLogin && tabshow">
      <div class="nxsite insite" @click="nxsite()">逆行监控网站</div>
      <div class="mesite" @click="mesite()">我的监控网站</div>
    </div>

    <div class="content">
      <div class="show concern" ref="concernH">
        <p v-if="!ifLogin" class="noTitle" style="margin-top: 10%;">您还未登录，请先<router-link :to="{name:'login'}">登录</router-link></p>
        
        <table v-if="ifLogin">
          <tr>
            <td>网站名称</td>
            <td>网站地址</td>
            <td>网站状态码</td>
            <td>网站响应速度</td>
            <td>网站地址2</td>
            <td>网站状态码2</td>
            <td>网站响应速度2</td>
            <td>取消关注</td>
          </tr>
          <tr v-for="(item,index) in webs" :key="index" class="webN">
            <td>{{item.name}}</td>
            <td>{{item.address}}</td>
            <td>{{item.resCode}}</td>
            <td>{{item.resTime}}</td>
            <td>{{item.address2}}</td>
            <td>{{item.resCode2}}</td>
            <td>{{item.resTime2}}</td>
            <td>
              <img :src="getLike(item)" class="tableLike"  @click='likes(index, $event)' alt />
            </td>
          </tr>
        </table>
        <div v-show='dataLength'>
          <img :src="noData" alt="">
          <div style="color:#ccc;font-size:14px;">当前无关注的网站</div>
        </div>
      </div>

    </div>
    <tabBottom></tabBottom>
  </div>
</template>

<script>
import axios from 'axios'
import NxNav from '../NxNav'
import UserInfo from "../user";
import tabBottom from "../tabBottom";
const likeImg = require("@/assets/like.png");
const unlikeImg = require("@/assets/unlike.png");
import { setUserInfo } from '@/js/utils'
import loginUser from "../user2"
export default {
  components: {
    NxNav,
    UserInfo,
    tabBottom,
    loginUser
  },
  data() {
    return {
      showTime: '',
      staff:[],
      thisPage:[],
      pageTotal: null,
      pageNum: 1,
      pageCount: 5,  
      report:[],
      projects:[],
      like:[],
      likeweb:[],
      web:[],
      webs:[],
      reports: '',
      projected:'',
      actPro: false,
      qc:[],
      proOn:-1,
      wxAppData:'',
      noData:require("../../assets/noData.png"),
      dataLength:false,
      loadingShow: true,
      projectData:{
        name: '',
        start_date:'',
        predict_test_date:'',
        test_date:'',
        end_date:'',
        run_date:[]
      },
      adds: false,
      tabshow: true
    }
  },
  mounted() {
    var me = this
    
    me.getShowTime()
    me.staffnames()
    me.staffReport()

    me.quchong()
    me.likewebs()
    me.tab()
    setInterval(me.getShowTime, 1000)
    if (me.$store.state.ifLogin) {
      setTimeout(function(){
        var bodyHieght = me.$refs.concernH.offsetHeight;
        var int = document.getElementsByClassName("content")[0];
        int.style.height = bodyHieght+'px';
      },1000)
    }
    if (!me.$store.state.ifLogin) {
      me.loadingShow = false;
    }
    if (me.$store.state.likeweb.length === 1) {
        me.dataLength = true;
      }
  },
  sockets:{
    staffReport:function(data){
      if (data[0]) {
        if(this.$store.state.ifLogin && this.ifYg){
          if (data[0].report) {
            this.report=data[0].report.split('\n日期')[0].trim();
          }
        }
      }
    },
 


    nameStaff:function(data){
      if(this.$store.state.ifLogin){
        this.like=data[0].likeweb.split(',').map(Number)
      }
      for(var i=0;i<this.like.length;i++){
        if(this.like[i]==0){
          continue;
        }
        this.likeweb.push(this.like[i])
      }
    },
    likeWeb:function(data){
      this.web.push(data[0])
      var w=[];
      var obj={};
      for(var i =0; i<this.web.length; i++){
        if (this.web[i]) {
          if(!obj[this.web[i].id]){
              w.push(this.web[i]);
              obj[this.web[i].id] = true;
          }
        }
      }
      this.webs=w
    },
    userSite:function(data){
      this.web.push(data[0])
      var w=[];
      var obj={};
      for(var i =0; i<this.web.length; i++){
        if (this.web[i]) {
          if(!obj[this.web[i].id]){
              w.push(this.web[i]);
              obj[this.web[i].id] = true;
          }
        }
      }
      this.webs=w
    },
    
    userInfo:function(data){
      var that=this; 
      setUserInfo.call(this, data)
      that.quchong();
      that.staffReport();
 
      that.likewebs();
      that.tab();
      setTimeout(function(){
        that.loadingShow = false;
      },500)
    },
    changeLike:function(data){
      this.$store.state.likeweb = data.split(',').map(Number);
      this.dataLength = false;
      if (this.$store.state.likeweb.length === 1) {
        this.dataLength = true;
      }
    }
  },
  methods: {
    tab(){
      var me = this;
      var spans = document.querySelectorAll(".header>span")
      var divs = document.querySelectorAll(".content>div")
      if (this.ifYg) {
        for(var i = 0; i < spans.length; i++){
          spans[i].setAttribute("data-id",i)
          spans[i].onclick = function () {
            for (var j = 0; j < spans.length;j++){
            spans[j].classList.remove("active")
            divs[j].classList.remove("show")
            divs[j].classList.add("hide")
          }
          this.classList.add("active")
          var index = this.getAttribute("data-id")
          divs[index].classList.add("show")
          divs[index].classList.remove("hide")
          }
        }
      }
      
      setTimeout(function(){
        me.loadingShow = false;
      },500)
    },
    quchong(){
      var me=this;
      me.qc = [];
      if (!this.adds) {
        for(var i=0;i<me.$store.state.likeweb.length;i++){
          if(me.$store.state.likeweb[i]==0){
            continue;
          }
          me.qc.push(me.$store.state.likeweb[i])
        }
      }else {
        for(var i=0;i<me.$store.state.userSite.length;i++){
          if(me.$store.state.userSite[i]==0){
            continue;
          }
          me.qc.push(me.$store.state.userSite[i])
        }
      }
    },
    authenticate(){
      var token=localStorage.getItem('jwt')
      if(token){
        this.$socket.emit('authenticate',{token})
      }
    },
    staffnames(){
      this.$socket.emit('nameStaff',{
        userName:this.$store.state.userName
      }); 
    },
    staffReport(){
      var me = this;
      me.$socket.emit("staffReport", {
        userName: this.$store.state.userName
      });
    },

    likewebs(){
      var me=this;
      this.web = [];
      this.webs = []
      for(var i=0;i<this.$store.state.likeweb.length;i++){
        me.$socket.emit('likeWeb',{
          id:me.qc[i]
        })
      }
    },
    userlikewebs(){
      var me=this;
      this.web = [];
      this.webs = []
      for(var i=0;i<this.$store.state.userSite.length;i++){
        me.$socket.emit('userSite',{
          id:me.qc[i]
        })
      }
    },
    getShowTime() {
      var me = this
      var nowTime = new Date()
      var year = nowTime.getFullYear()
      var month = nowTime.getMonth() + 1
      var date = nowTime.getDate()
      var hour = nowTime.toLocaleTimeString()
      me.showTime = year + '-' + month + '-' + date + ' ' + hour
    },
    handleCurrentChange(val){
      var me=this;
      me.pageNum=val;
    },
    actPros(e,index,data){
      this.proOn = e;
      this.actPro = !this.actPro;
      this.projectData = data;
      if (this.projectData.run_date.length === 0) {
        this.projectData.run_date =  [
              {
                run_start_date: '',
                run_end_date: '',
                id: 1
              }
            ]
      }
    },
    hidePro(){
      this.actPro = !this.actPro;
 
    },
    getLike(item) {
      if (!this.adds) {
        if (this.$store.state.likeweb) {
          return this.$store.state.likeweb.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.likeweb) {
          return unlikeImg;
        }
      }else{
        if (this.$store.state.userSite) {
          return this.$store.state.userSite.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.userSite) {
          return unlikeImg;
        }
      }
    },
    likes(index, evt){
      if(!this.ifLogin){
        this.$router.push('/')
      }
      else{
        if (!this.adds) {
          if(this.$store.state.likeweb.indexOf(this.webs[index].id) == -1){
            this.$store.commit('addlikeWeb',this.webs[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
          else{
            this.$store.commit('deletelikeWeb',this.webs[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
            var webN = document.getElementsByClassName("webN")[index];
            webN.style.display = 'none';
          }
        }else {
          if(this.$store.state.userSite.indexOf(this.webs[index].id) == -1){
            this.$store.commit('adduserSite',this.webs[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
          }
          else{
            this.$store.commit('deleteuserSite',this.webs[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple
            })
            var webN = document.getElementsByClassName("webN")[index];
            webN.style.display = 'none';
          }
        }
      }
    },

    changeHeightF(){
      var bodyHieght = this.$refs.concernH.offsetHeight;
      var int = document.getElementsByClassName("content")[0];
      var spans = document.querySelectorAll(".header>span")
      var divs = document.querySelectorAll(".content>div")
      int.style.height = bodyHieght+'px';
      this.tabshow = true;
      if (!this.ifYg) {
        spans[0].classList.add("active")
        spans[1].classList.remove("active")
        divs[0].classList.add("show")
        divs[0].classList.remove("hide")
        divs[3].classList.add("hide")
        divs[3].classList.remove("show")
      }
    },
    editProject(data){
      // console.log('data',data)
    
    },
    editAddRunDateArray(){
      var me = this
      var text = {
        run_start_date: '',
        run_end_date: '',
        id: me.projectData.run_date.length + 1
      }
      me.projectData.run_date.push(text)
    },
    editdeleteRunDateArray(index){
      var me = this
      if (me.projectData.run_date.length > 1) {
        me.projectData.run_date.splice(index, 1)
      }
    },
    nxsite: function() {
      this.adds = false;
      this.quchong();
      document.getElementsByClassName("nxsite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("mesite")[0].style.color = '#ffffff';
      this.likewebs();
    },
    mesite: function() {
      this.adds = true;
      this.quchong();
      document.getElementsByClassName("mesite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("nxsite")[0].style.color = '#ffffff';
      this.userlikewebs();
    },
  },
  computed:{

    ifLogin() {
      return this.$store.state.ifLogin;
    },
    userName() {
      return this.$store.state.userName;
    },
    ifYg(){
      return this.$store.state.ifYg;
    },
    likewebss(){
      return this.$store.state.likeweb;
    },
    userImage(){
      return this.$store.state.userImage;
    },
  },
}
</script>

<style lang="less" scoped>
.business{
  position: relative;
  padding-top: 30px;
  padding-bottom: 80px;
  .mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(23, 23, 23, 0.8);
  }
  .editPro{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    .editBox{
      z-index: 1000;
      position: absolute;
      width: 50%;
      // height: 370px;
      left: 0;
      right: 0;
      margin: 0 auto;
      margin-top: 60px;
      background: #181e26;
      border-radius: 3%;
      color: #fff;
      font-size: 16px;
      text-align: left;
      overflow: hidden;
      .editTitle{
        text-align: center;
        padding: 5px 0;
      }
      .editContent{
        padding: 15px 20px;
        div{
          padding: 3px 0;
          span{
            display: inline-block;
          }
          span:first-child{
            width: 180px;
          }
        }
        .editBtn{
          padding-top: 20px;
          text-align: right;
          span{
            width: 100px;
            text-align: right;
            button{
              width: 60px;
              height: 30px;
              padding: 8px 10px;
              color: #fff;
              background: #222a36;
              border: 0;
              box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2),0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 3px rgba(0, 0, 0, 0.12) !important;
            }
            button:hover{
              color: #21a2f5;
            }
          }
          span:first-child{
            width: 100px;
            margin-right: 30px;
          }
        }
        .otherTime{
          margin-top: 5px;
        }
        .el-button{
          padding: 3px;
        }
      }
    }
  }
  .editData{
    height: 100%;
    transition: all 1s;
  }
    .loading{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: #181e26;
      .loadingImg{
        width: 320px;
        height: 240px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
  .ysxy{
    color:#fff;
    font-size: 14px;
    text-decoration: none;
  }
  .header{
    margin:40px 0 20px 0;
    span{
      cursor: pointer;
      margin:0 20px;
      color:#fff;
      font-size: 16px;
      &:hover{
        color:#4f86ed;
      }
    }
    .active{
      color:#4f86ed;
    }
  }
  .switchSite {
    width: 90vw;
    height: 40px;
    margin: 10px auto;
    align-self: center;
    line-height: 40px;
    text-align: left;
    font-size: 12px;
    div {
      height: 30px;
      line-height: 25px;
      display: inline-block;
      cursor: pointer;
      border: 1px solid rgb(148, 146, 146);
      padding: 2px 5px;
      margin-right: 5%;
      border-radius: 10px;
      color: #fff;
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
    }
    .insite{
      color: rgb(33, 162, 245);
    }
  }
  .content{
    position: relative;
    
    width: 90vw;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0 auto;
    .concern{
      margin:auto;
      p{
        color:#fff;
        font-size: 18px;
        a{
          text-decoration: none;
          color:cornflowerblue;
        }
      }
      .noTitle{
        width: 90vw;
        text-align: center;
      }
      table {
        background-color: #20252f;
        border-collapse: collapse;
        border-spacing: 0;
        width: 90vw;
        color: #fff;
        table-layout: fixed;
        font-size: 12px;
        border-radius: 10px;
        box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
        
        tr {
          border-bottom: 1px solid #666;
          td {
            height: 50px;
            word-break: break-all;
            font-size: 12px;
          }
        }
        tr:nth-child(1) td{
          color:#aaa;
          font-size: 14px;
        }
        tr:last-child{
          border-bottom: 0;
        }
        .webN:nth-child(even){
          background: rgba(117, 176, 243, 0.3);
        }
      }
    
    }
    .report{
      width: 90vw;
      margin:auto;
      p{
        color:#fff;
        font-size: 18px;
      }
      .zb pre{
        background-color: #20252f;
        padding:10px 0 10px 30px;
        border-radius: 10px;
        text-align: left;
        margin-left:20px;
        font-size: 12px;
        white-space:pre-wrap;
        word-wrap:break-word;
        box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);  
      }
    }
    .project{
      width:90vw;
      margin:auto;
      p{
        color:#fff;
        font-size: 18px;
      }
      .edit{
        cursor: pointer;
      }
      table{
        width: 100%;
        color:#fff;
        background-color: #20252f;
        border-collapse: collapse;
        border-spacing: 0;
        margin-bottom: 20px;
        box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
        border-radius: 10px;
        tr{
          border-bottom: 1px solid #666;
          td{
            width: auto;
            height: 50px;
            font-size: 12px;
          }
        }
        tr:nth-child(1) td{
          color:#aaa;
          font-size: 14px;
        }
        tr:last-child{
          border-bottom: 0;
        }
        tr:nth-child(even){
          background: rgba(117, 176, 243, 0.3);
        }
      }
      .el-dropdown-link{
        color: #fff;
      }
    }
    >div{
      position: absolute;
      top: 0;
      opacity: 0;
      right: -110%;
    }
    .show{
      animation: showlist 0.8s;
      animation-fill-mode: forwards;
    }
    .hide{
      animation: hidelist 0.8s;
      animation-fill-mode: forwards;
    }
    .tableLike{
      width: 25px;
      height: 25px;
      cursor: pointer;
    }
  }
}
@keyframes showlist{
  0% { 
    opacity: 0;
    right: -50%;
  }
  50% {
    opacity: 1;
    right: 0%;
	}
	100% {
    opacity: 1;
    right: 0%;
    display: block;
	}  
}
@keyframes hidelist{
  0% { 
    opacity: 1;
    right: 0%;
    display: block;
  }
  50% {
    opacity: 0;
    right:-15%;
	}  
	100% {
    opacity: 0;
    right:-110%;
    display: none;
	}  
}
</style>




// WEBPACK FOOTER //
// src/components/pc/PCMe.vue